import { render } from "./ResourceIdentifier.vue?vue&type=template&id=2106576b"
import script from "./ResourceIdentifier.vue?vue&type=script&lang=ts"
export * from "./ResourceIdentifier.vue?vue&type=script&lang=ts"
script.render = render

export default script